// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"VerificacionDetalle_spinnerContainer__PQ1ey"};